import { i18n } from '@lingui/core'

export function renderFullPath(imagePath = ''): string {
    const path = `/${imagePath}`;
    const imageUrl = new URL(path, import.meta.url);
    return imageUrl.href;
  }

  export function formatText(s: string): string {
    return s.replace(/ ([!:?])/g, '\u00A0$1')
  }

  export function formatDate(date: Date): string {
      return new Date(date).toLocaleDateString('fr-FR', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
      });
    }


    export function renderNameOrYou(name?: string, userName?: string): string {
      return name === userName  ? i18n._('common.you') : name || ''
    }
